var _defs, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "instagram",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 501.64 501.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-1117.57,393.44v222a139.81,139.81,0,0,1-139.81,139.82h-222a139.81,139.81,0,0,1-139.82-139.82v-222a139.81,139.81,0,0,1,139.82-139.8h222a139.8,139.8,0,0,1,139.81,139.8",
    transform: "translate(1619.21 -253.64)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-1366.59,558.73a54.37,54.37,0,0,1-56.06-56.07,54.45,54.45,0,0,1,52.46-52.47,54.36,54.36,0,0,1,56.06,56.07A54.44,54.44,0,0,1-1366.59,558.73Zm-.57-142a87.87,87.87,0,0,0-89,89,88,88,0,0,0,86.54,86.54,87.88,87.88,0,0,0,89-89,88,88,0,0,0-86.55-86.54",
    transform: "translate(1619.21 -253.64)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-1232.81,576.23a63.81,63.81,0,0,1-63.81,63.82h-143.54A63.81,63.81,0,0,1-1504,576.23V432.69a63.8,63.8,0,0,1,63.81-63.8h143.54a63.81,63.81,0,0,1,63.81,63.8Zm-63.8-240.84h-143.55a97.31,97.31,0,0,0-97.3,97.3V576.23a97.3,97.3,0,0,0,97.3,97.3h143.54a97.31,97.31,0,0,0,97.31-97.3V432.69a97.31,97.31,0,0,0-97.3-97.3",
    transform: "translate(1619.21 -253.64)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-1277.91,391.34a23,23,0,0,0-24.43,24.41,23.05,23.05,0,0,0,21.42,21.44,23,23,0,0,0,24.43-24.44,23,23,0,0,0-21.42-21.41",
    transform: "translate(1619.21 -253.64)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.61fb6d4accb4cd67f0e048c5ac4eefba.svg";
export { ForwardRef as ReactComponent };